import React from 'react';
import { useTranslation } from 'react-i18next';
import { OMEGA3_BENEFITS } from '../data/omega3Data';
import { Icons } from '../../elements/icon/resolver';

const Omega3BenefitsSection = () => {
  const { t } = useTranslation();

  return (
    <section className="t-bg-white t-py-16 md:t-py-20">
      <div className="container !t-max-w-[1200px]">
        <div className="t-text-center">
          <h2
            className="!t-m-0 t-text-[32px] md:t-text-[42px] t-leading-[1.1] t-text-navy"
            style={{ fontFamily: 'DM Serif Display, serif' }}
          >
            {t('Omega3_Benefits_Title')}
          </h2>
        </div>

        <div className="t-mt-10 t-grid t-grid-cols-1 lg:t-grid-cols-3 t-gap-5">
          {OMEGA3_BENEFITS.map((benefit) => (
            (() => {
              const iconKeyByBenefit = {
                brain: 'omegaBrain',
                heart: 'omegaHeart',
                vision: 'omegaVision',
              };
              const IconComponent = Icons[iconKeyByBenefit[benefit.icon]] || Icons.omegaBrain;

              return (
            <article
              key={benefit.titleKey}
              className="t-rounded-[16px] t-border t-border-g200 t-bg-surface t-px-7 t-py-8 t-text-center"
            >
              <span className="t-inline-flex t-items-center t-justify-center t-text-quiz-teal">
                <IconComponent className="t-h-10 t-w-10" color="currentColor" size="28" />
              </span>
              <h3
                className="t-mt-5 t-text-lg lg:t-text-xl t-font-bold t-leading-[1.2] t-text-navy"
                style={{ fontFamily: 'DM Serif Display, serif' }}
              >
                {t(benefit.titleKey)}
              </h3>
              <p className="t-mt-3 t-text-sm lg:t-text-base] t-leading-[1.65] t-text-g500">
                {t(benefit.bodyKey)}
              </p>
            </article>
              );
            })()
          ))}
        </div>

        <p className="t-mt-6 t-text-center t-text-[14px] t-italic t-text-g500">{t('Omega3_Benefits_Footnote')}</p>
      </div>
    </section>
  );
};

export default Omega3BenefitsSection;
